export default __webpack_public_path__ + "static/media/traditional-icon-white.b6a9b1b7.svg";